var _defs, _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEbusinessRedPackets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ebusiness-red-packets_svg__a",
    d: "M11.1 10.1c.2 0 .3.1.3.3v.6c0 .2-.1.3-.3.3H9.7v.6h1.4c.2 0 .3.1.3.3v.6c0 .2-.1.3-.3.3H9.7v.8c0 .2-.1.3-.3.3h-.5c-.2 0-.3-.1-.3-.3v-.8H7.2c-.2 0-.3-.1-.3-.3v-.6c0-.2.1-.3.3-.3h1.4v-.6H7.2c-.2 0-.3-.1-.3-.3v-.6c0-.2.1-.3.3-.3h.9l-1.2-2c-.1-.2 0-.3.1-.4l.5-.3c.1-.1.3 0 .4.1l1.3 2.2 1.3-2.2c.1-.1.2-.2.4-.1l.5.3c.1.1.2.2.1.4l-1.2 2h.8zM4.3 1.7h9.6c.6 0 1.1.5 1.1 1.1v12.4c0 .6-.5 1.1-1.1 1.1H4.3c-.6 0-1.1-.5-1.1-1.1V2.9c0-.7.5-1.2 1.1-1.2zm0 3.2v10.3h9.6V4.9L9.3 6.5h-.4L4.3 4.9zm0-1.2l4.8 1.6 4.8-1.6v-.8H4.3v.8z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ebusiness-red-packets_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ebusiness-red-packets_svg__a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ebusiness-red-packets_svg__b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ebusiness-red-packets_svg__c",
    d: "M-449.9-1311.9h1424v1994h-1424z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ebusiness-red-packets_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ebusiness-red-packets_svg__c",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#ebusiness-red-packets_svg__d)",
    d: "M-1.8-3.3H20v24.6H-1.8z"
  }))));
}

export default SvgEbusinessRedPackets;